module.exports = __webpack_public_path__ + "img/CD.6fa4502a.svg";